import type { JSX } from 'react';
import { Navigate } from 'react-router';
import { useShellContext } from '../shell/context.js';
import { SitePage } from './SitePage.js';

/**
 * L'éditeur de site n'est plus ouvert aux galeries : le site est une
 * prestation à part, demandée depuis `demande-site`. Seul un accès de support
 * garde l'éditeur ; tout autre compte est renvoyé vers la demande, y compris
 * par une ancienne adresse.
 */
export function EditeurSiteGarde(): JSX.Element {
  const { galerie, galerieSlug } = useShellContext();
  if (!galerie.support) return <Navigate replace to={`/${galerieSlug}/demande-site`} />;
  return <SitePage />;
}
